module.exports = __webpack_public_path__ + "images/settings@1x.png?5180164a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/settings@1x.png
// module id = 698
// module chunks = 7